import Vue from 'vue';
import { auth } from 'api';
import { lsSetAuthToken, lsGetAuthToken, lsRemoveAuthToken } from 'helpers/store';
import {
  AUTH_REQUEST,
  AUTH_ERROR,
  AUTH_SUCCESS,
  AUTH_LOGOUT,
  AUTH_VALIDATE
} from 'store/actions/auth';

export default {
  // Validate the token and update it with new API data if it is not valid
  [AUTH_VALIDATE]: ({ dispatch, getters }) => {
    if (getters.isAuthenticated) {
      // TODO: Verificar aquí si el token es valido por el tiempo
      const authToken = lsGetAuthToken();
      if (authToken && authToken.access_token) {
        Vue.signalr.updateAuthToken(authToken.access_token);
      }
      return Promise.resolve();
    }
    return dispatch(AUTH_REQUEST);
  },

  [AUTH_REQUEST]: ({ commit }) =>
    new Promise((resolve, reject) => {
      commit(AUTH_REQUEST);
      auth
        .startSessionApi({
          clientId: process.env.API_CLIENT_ID,
          clientSecret: process.env.API_CLIENT_SECRET,
          scope: process.env.API_SCOPE,
          grantType: process.env.API_GRANT_TYPE
        })
        .then(
          resp => {
            const data = resp.data;
            lsSetAuthToken(data);
            commit(AUTH_SUCCESS, data);
            Vue.signalr.updateAuthToken(data.access_token);
            resolve(data);
          },
          err => {
            commit(AUTH_ERROR, err);
            lsRemoveAuthToken();
            reject();
          }
        );
    }),

  [AUTH_LOGOUT]: ({ commit }) =>
    new Promise(resolve => {
      commit(AUTH_LOGOUT);
      lsRemoveAuthToken();
      resolve();
    })
};
